<script setup lang="ts">
import { useLanguage } from '../composables/useLanguage'
import type { Language } from '../types/locale'

// Example:
// <language-view lang="th" @after-enter="" @after-leave="">
//    <img src="/images/lang-th.png"/>
// </language-view>
//
// <language-view lang="en">
//    <img src="/images/lang-en.png"/>
// </language-view>

const props = defineProps<{
  lang: Language
}>()

const { currentLang } = useLanguage()
</script>

<template>
  <transition name="fade" mode="out-in">
    <div v-show="props.lang == currentLang" class="language-view" :lang="props.lang">
      <slot></slot>
    </div>
  </transition>
</template>

<style scoped>
.language-view {
  position: absolute;
}
</style>
